import script from "./ServiceChannelStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceChannelStatistics.vue?vue&type=script&setup=true&lang=js"

import "./ServiceChannelStatistics.vue?vue&type=style&index=0&id=e1727160&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1727160"]])

export default __exports__